export default __webpack_public_path__ + "static/jerry-eceb6ea8371a963bba3dd33d1a4ee898.png";